export interface BatchIgnoreRequest {
    /**
     * 问题 ID
     */
    check_result_id: string[];
}

export type BatchIgnoreResponse = void;

export const BatchIgnoreApi = Symbol.for('BatchIgnoreApi');

export interface BatchIgnoreApi {
    batchIgnore(data: BatchIgnoreRequest): Promise<BatchIgnoreResponse>;
}
